import React, { useState } from "react";
import { List, NumberField, TextField } from "react-admin";
import classnames from "classnames";
import { makeStyles } from "@material-ui/core";

import MyDatagrid from "../customise/CustomDataGrid";
import { CommonFilter } from "../helpers/commonFilters";
// import exporters from "../helpers/exporters";
import { getParameterByName, getDefaultTime, filtersChanged, allFilters } from "../helpers/utils";
import { authProvider } from "../provider/provider";
import { resources } from "../provider/configs";

const useStyles = makeStyles({
  failed: { color: "red" },
  passed: { color: "green" },
  boldy: { fontWeight: "bold" },
});

const notPass = (perf, target) => perf < Number.parseFloat(target);

const PerformanceField = (props) => {
  const classes = useStyles();
  let fail = notPass(props.record["performance"], props.record.target);
  return (
    <span
      className={classnames({
        [classes.failed]: fail,
        [classes.passed]: !fail,
        [classes.boldy]: true,
      })}
    >
      {props.record["performance"]} %
    </span>
  );
};

const rowStyle = (record, index) => {
  if (record.isGroupHeader) {
    return {
      height: "2em",
      backgroundColor: "#dde6e9",
      textAlign: "center",
      fontSize: "2em",
      fontWeight: "bold",
    };
  }
  return {};
};

export const QAAsList = ({ ...props }) => {
  let filter = getParameterByName("filter") || "{}";
  filter = JSON.parse(filter);
  let { year, month } = getDefaultTime();

  let [stateFilter, setStateFilter] = useState({
    displayed: allFilters(filter),
    vendor: filter.vendor,
    cost_center: filter.cost_center,
    year: filter.year || year,
    month: filter.month || month,
  });

  function filtersUpdated(filters) {
    if (filtersChanged(filters, stateFilter)) {
      if (!allFilters(filters)) {
        setStateFilter({ ...filters, displayed: false });
      } else {
        setStateFilter({ ...filters, displayed: true });
      }
    }
  }

  const isEditAllowed = () => authProvider.isAllowed(props.permissions, resources.qaas.app.name, "update");
  let total_fields = [{ field: "performance", key: "total_response" }];
  return (
    <div>
      <List
        {...props}
        bulkActionButtons={false}
        filters={<CommonFilter filtersUpdated={filtersUpdated} />}
        filterDefaultValues={{ year, month }}
        pagination={false}
        title="QAAs List"
        exporter={false}
        // exporter={(d) => exporters(d, "qaas")}
      >
        <MyDatagrid
          groupby={"qaa_item.qaa_zone.label"}
          rowStyle={rowStyle}
          rowClick={(id, basePath, record) => (record.isGroupHeader || !isEditAllowed() || id.match(/future/i) ? null : "edit")}
          colSpan={3}
          total_fields={total_fields}
          toSum={["qaa_item.valueToScore", "percentage"]}
        >
          <NumberField source="qaa_item.criticality" label="Criticality" />
          <TextField sortable={false} source="qaa_item.description" label="Description" />
          <NumberField source="qaa_item.valueToScore" unit={"%"} label="Value To Score" />
          <NumberField sortable={false} unit={"%"} source="score" label="Score" />
          <NumberField sortable={false} unit={"%"} source="percentage" label="Percentage" />
          <TextField sortable={false} source="Justification" label="Justification" />
        </MyDatagrid>
      </List>
    </div>
  );
};
